(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dl-article-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    var container = document.querySelector('.dl-article-content__container');
    if (!container) return;

    // Drop-cap: lift the first letter of the first article paragraph.
    // Move the drop-cap aside to sit immediately before that paragraph so the
    // float aligns with it — covers articles that lead with a table, h2, or TOC card.
    var paragraphFirstLetter = container.querySelector('.dl-article-content__dropcap');
    var firstParagraph = null;
    var directChildren = container.children;
    for (var i = 0; i < directChildren.length; i++) {
      var child = directChildren[i];
      if (child === paragraphFirstLetter) continue;
      if (child.tagName === 'P' && (child.textContent || '').trim().length > 0) {
        firstParagraph = child;
        break;
      }
    }
    if (paragraphFirstLetter && firstParagraph) {
      var firstParagraphContent = firstParagraph.textContent;
      var firstParagraphFirstLetter = firstParagraphContent.charAt(0);
      firstParagraph.textContent = firstParagraphContent.slice(1);
      firstParagraph.style.fontSize = "20px";
      paragraphFirstLetter.textContent = firstParagraphFirstLetter;
      firstParagraph.parentNode.insertBefore(paragraphFirstLetter, firstParagraph);
    } else if (paragraphFirstLetter) {
      paragraphFirstLetter.style.display = 'none';
    }

    // Wire up TOC anchors: map each TOC link to the matching section heading
    // (paragraphs whose only meaningful child is a <strong> "1. Title" line).
    var tocLinks = document.querySelectorAll('.dl-article-toc__link');
    if (tocLinks.length === 0) return;

    var headingPattern = /^\s*\d+\.\s/;
    var sectionHeadings = Array.prototype.filter.call(
      container.querySelectorAll(':scope > p'),
      function (p) {
        var strong = p.querySelector('strong');
        return strong && headingPattern.test(strong.textContent || '');
      }
    );

    tocLinks.forEach(function (link, i) {
      var heading = sectionHeadings[i];
      if (!heading) return;
      var href = link.getAttribute('href') || '';
      var id = href.charAt(0) === '#' ? href.slice(1) : '';
      if (id && !heading.id) heading.id = id;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dl-articles-grid-related"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var sliders = document.querySelectorAll('.dl-related-slider');
    if (!sliders.length || typeof Swiper === 'undefined') return;

    sliders.forEach(function (root) {
      var container = root.querySelector('.dl-related-slider__swiper');
      if (!container) return;
      var nextEl = root.querySelector('.dl-related-slider__button--next');
      var prevEl = root.querySelector('.dl-related-slider__button--prev');
      var paginationEl = root.querySelector('.dl-related-slider__pagination');

      try {
        var swiper = new Swiper(container, {
          loop: false,
          spaceBetween: 16,
          slidesPerView: 1.15,
          breakpoints: {
            480:  { slidesPerView: 1.4, spaceBetween: 18 },
            640:  { slidesPerView: 1.7, spaceBetween: 22 },
            768:  { slidesPerView: 2.2, spaceBetween: 26 },
            1024: { slidesPerView: 3,   spaceBetween: 32 },
            1280: { slidesPerView: 3,   spaceBetween: 36 }
          },
          navigation: { nextEl: nextEl, prevEl: prevEl },
          pagination: { el: paginationEl, clickable: true },
          a11y: {
            prevSlideMessage: 'Previous article',
            nextSlideMessage: 'Next article'
          },
          watchSlidesProgress: true
        });

        // Backup click handlers — Swiper sometimes misses externally-placed nav buttons.
        if (nextEl) {
          nextEl.addEventListener('click', function (e) {
            e.preventDefault();
            swiper.slideNext();
          });
        }
        if (prevEl) {
          prevEl.addEventListener('click', function (e) {
            e.preventDefault();
            swiper.slidePrev();
          });
        }
      } catch (err) {
        console.error('DL Related Slider init failed:', err);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dl-faqs-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Find all FAQs slider sections on the page
  const sliderSections = document.querySelectorAll('.dl-faqs-slider');
  
  sliderSections.forEach(function(sliderElement) {
    const sectionId = sliderElement.dataset.sectionId;
    const swiperContainer = sliderElement.querySelector('.swiper');
    
    if (swiperContainer && typeof Swiper !== 'undefined') {
      const nextButton = sliderElement.querySelector('.dl-faqs-slider__button--next');
      const prevButton = sliderElement.querySelector('.dl-faqs-slider__button--prev');
      
      try {
        // Initialize Swiper for this specific instance
        const swiper = new Swiper(swiperContainer, {
          // Basic settings
          loop: false,
          spaceBetween: 30,
          
          // Show one slide at a time (each slide contains 3 FAQs)
          slidesPerView: 1,
          
          // Navigation arrows
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
          
          // Accessibility
          a11y: {
            prevSlideMessage: 'Previous FAQs',
            nextSlideMessage: 'Next FAQs',
          }
        });
        
        // Add manual click handlers as backup
        if (nextButton && prevButton) {
          nextButton.addEventListener('click', function() {
            swiper.slideNext();
          });
          
          prevButton.addEventListener('click', function() {
            swiper.slidePrev();
          });
        }
        
      } catch (error) {
        console.error('DL FAQs Slider: Error initializing Swiper:', error);
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dl-hero-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const sliderSections = document.querySelectorAll('.dl-hero-banner');

  sliderSections.forEach(function(sliderElement) {
    const swiperContainer = sliderElement.querySelector('.swiper');

    if (swiperContainer && typeof Swiper !== 'undefined') {
      const nextButton = sliderElement.querySelector('.dl-hero-banner__button--next');
      const prevButton = sliderElement.querySelector('.dl-hero-banner__button--prev');
      const progressEl = sliderElement.querySelector('.dl-hero-banner__progress');

      try {
        const swiper = new Swiper(swiperContainer, {
          loop: true,
          slidesPerView: 1,
          spaceBetween: 20,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false
          },
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton
          },
          a11y: {
            prevSlideMessage: 'Previous banner',
            nextSlideMessage: 'Next banner'
          },
          on: {
            autoplayTimeLeft: function (swiperInstance, time, progress) {
              // progress = 1.0 at slide start, 0.0 right before advance
              if (progressEl) {
                progressEl.style.setProperty('--dl-hero-progress', 1 - progress);
              }
            }
          }
        });

        if (nextButton && prevButton) {
          nextButton.addEventListener('click', function() {
            swiper.slideNext();
          });

          prevButton.addEventListener('click', function() {
            swiper.slidePrev();
          });
        }
      } catch (error) {
        console.error('DL Banner Slider: Error initializing Swiper:', error);
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dl-logo-slider-mobile"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Only initialize on mobile devices
  if (window.innerWidth <= 767) {
    // Find all logo slider sections on the page
    const logoSliders = document.querySelectorAll('.dl-logo-slider-mobile');
    
    logoSliders.forEach(function(sliderElement) {
      const track = sliderElement.querySelector('.dl-logo-slider-mobile__track');
      
      if (track) {
        // Get all logo items
        const items = track.querySelectorAll('.dl-logo-slider-mobile__item');
        const itemCount = items.length / 2; // Divided by 2 because we duplicate
        
        // Calculate total width needed
        let totalWidth = 0;
        for (let i = 0; i < itemCount; i++) {
          totalWidth += items[i].offsetWidth + 40; // Include gap
        }
        
        // Set animation duration based on width
        const duration = totalWidth / 30; // 30 pixels per second
        track.style.animationDuration = duration + 's';
        
        // Handle touch for mobile - pause on touch
        track.addEventListener('touchstart', function(e) {
          track.style.animationPlayState = 'paused';
        }, { passive: true });
        
        track.addEventListener('touchend', function(e) {
          track.style.animationPlayState = 'running';
        }, { passive: true });
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dl-navigation-bottom"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Update current year dynamically
  const yearElements = document.querySelectorAll('.is-current-year');
  const currentYear = new Date().getFullYear();
  
  yearElements.forEach(function(element) {
    element.textContent = currentYear;
  });
  
  // Newsletter Modal Functionality
  const modal = document.getElementById('newsletterModal');
  const triggers = document.querySelectorAll('[data-newsletter-trigger]');
  const closeButtons = document.querySelectorAll('[data-newsletter-close]');
  
  // Open modal
  triggers.forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      modal.classList.add('is-active');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      
      // Focus first input
      setTimeout(function() {
        const firstInput = modal.querySelector('#modal-name');
        if (firstInput) firstInput.focus();
      }, 100);
    });
  });
  
  // Close modal
  function closeModal() {
    modal.classList.remove('is-active');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  
  closeButtons.forEach(function(button) {
    button.addEventListener('click', closeModal);
  });
  
  // Close on ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('is-active')) {
      closeModal();
    }
  });

  // Klaviyo dual-capture: mirror newsletter signups into the client's Klaviyo
  // list before the native Shopify POST navigates away. RMWKMy is the public
  // site ID already exposed by the Klaviyo onsite embed.
  const klaviyoForms = document.querySelectorAll('form[data-klaviyo-newsletter]');

  klaviyoForms.forEach(function(form) {
    form.addEventListener('submit', function() {
      const listId = form.getAttribute('data-klaviyo-list');
      const emailInput = form.querySelector('input[name="contact[email]"]');
      const nameInput = form.querySelector('input[name="contact[first_name]"]');

      if (!listId || !emailInput || emailInput.value === '') {
        return; // nothing to mirror; the native Shopify submit still proceeds
      }

      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Footer Newsletter',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: emailInput.value,
                  first_name: nameInput ? nameInput.value : '',
                  subscriptions: {
                    email: { marketing: { consent: 'SUBSCRIBED' } }
                  }
                }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: listId } }
          }
        }
      };

      // keepalive lets the request complete while the page navigates to /contact
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=RMWKMy', {
        method: 'POST',
        keepalive: true,
        headers: {
          'Content-Type': 'application/vnd.api+json',
          revision: '2025-04-15'
        },
        body: JSON.stringify(payload)
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dl-navigation-top-collection"] && !Shopify.designMode) return;
  try {
    
// Helper function to format money using Shopify's format
function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || '${{amount}}';

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision || 2;
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(number) || number === null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  const match = formatString.match(placeholderRegex);
  if (!match) {
    // If format doesn't match expected pattern, return a simple formatted number
    return formatString.replace(/\d+/, (cents / 100.0).toFixed(2));
  }

  switch (match[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'", '.');
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }

  return formatString.replace(placeholderRegex, value);
}

document.addEventListener('DOMContentLoaded', function() {
  const nav = document.querySelector('.dl-navigation-top');
  const mobileMenu = document.querySelector('.dl-navigation-mobile-menu');
  const menuToggle = document.querySelector('.dl-navigation-top__menu-toggle');
  const menuClose = document.querySelector('.dl-navigation-mobile-menu__close');
  const menuOverlay = document.querySelector('.dl-navigation-mobile-menu__overlay');
  const menuLinks = document.querySelectorAll('.dl-navigation-mobile-menu__links a');
  let lastScrollTop = 0;
  
  // Handle scroll events for background color change
  function handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (scrollTop > 50) {
      nav.classList.add('dl-navigation-top--scrolled');
    } else {
      nav.classList.remove('dl-navigation-top--scrolled');
    }
    
    lastScrollTop = scrollTop;
  }
  
  // Throttle scroll events for performance
  let scrollTimer;
  window.addEventListener('scroll', function() {
    if (scrollTimer) {
      clearTimeout(scrollTimer);
    }
    scrollTimer = setTimeout(handleScroll, 10);
  });
  
  // Mobile menu toggle functions
  function openMobileMenu() {
    mobileMenu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    
    // Trap focus in menu
    menuClose.focus();
  }
  
  function closeMobileMenu() {
    mobileMenu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    
    // Return focus to toggle button
    menuToggle.focus();
  }
  
  // Event listeners for mobile menu
  if (menuToggle) {
    menuToggle.addEventListener('click', openMobileMenu);
  }
  
  if (menuClose) {
    menuClose.addEventListener('click', closeMobileMenu);
  }
  
  if (menuOverlay) {
    menuOverlay.addEventListener('click', closeMobileMenu);
  }
  
  // Close menu when clicking on a link (optional - remove if you want menu to stay open)
  menuLinks.forEach(function(link) {
    link.addEventListener('click', function() {
      // Only close on mobile
      if (window.innerWidth < 900) {
        closeMobileMenu();
      }
    });
  });

  // Shop dropdown (desktop) + accordion (mobile) - DL-3009
  const shopDropdowns = document.querySelectorAll('[data-dropdown]');
  shopDropdowns.forEach(function(dropdown) {
    const toggle = dropdown.querySelector('.dl-navigation-top__dropdown-toggle');
    if (!toggle) {
      return;
    }
    let suppressFocusOpen = false;

    function setOpen(isOpen) {
      dropdown.classList.toggle('is-open', isOpen);
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    // Touch/pen: the focus that follows a tap must not pre-open the menu, or the
    // first tap would navigate instead of opening. Suppress focus-open for it.
    dropdown.addEventListener('pointerdown', function(event) {
      if (event.pointerType !== 'mouse') {
        suppressFocusOpen = true;
      }
    });
    dropdown.addEventListener('pointerup', function() {
      window.setTimeout(function() {
        suppressFocusOpen = false;
      }, 0);
    });

    // Mouse hover opens/closes; touch is handled by the click below so the first
    // tap opens rather than navigating
    dropdown.addEventListener('pointerenter', function(event) {
      if (event.pointerType === 'mouse') {
        setOpen(true);
      }
    });
    dropdown.addEventListener('pointerleave', function(event) {
      if (event.pointerType === 'mouse' && !dropdown.contains(document.activeElement)) {
        setOpen(false);
      }
    });

    // Keyboard focus opens; leaving the group closes
    dropdown.addEventListener('focusin', function() {
      if (!suppressFocusOpen) {
        setOpen(true);
      }
    });
    dropdown.addEventListener('focusout', function(event) {
      if (!dropdown.contains(event.relatedTarget)) {
        setOpen(false);
      }
    });

    // First tap/click opens the menu (when closed) instead of following the link;
    // a second interaction (already open) navigates to All Products
    toggle.addEventListener('click', function(event) {
      if (toggle.getAttribute('aria-expanded') !== 'true') {
        event.preventDefault();
        setOpen(true);
      }
    });

    // Escape closes and restores focus to the toggle without immediately reopening
    dropdown.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        setOpen(false);
        suppressFocusOpen = true;
        toggle.focus();
        window.setTimeout(function() {
          suppressFocusOpen = false;
        }, 0);
      }
    });
  });

  // Close an open desktop dropdown when clicking outside it
  if (shopDropdowns.length) {
    document.addEventListener('click', function(event) {
      shopDropdowns.forEach(function(dropdown) {
        if (!dropdown.contains(event.target)) {
          dropdown.classList.remove('is-open');
          const outsideToggle = dropdown.querySelector('.dl-navigation-top__dropdown-toggle');
          if (outsideToggle) {
            outsideToggle.setAttribute('aria-expanded', 'false');
          }
        }
      });
    });
  }

  // Mobile slide-out Shop accordion; `inert` keeps collapsed links out of the tab
  // order and off assistive tech
  const mobileDropdowns = document.querySelectorAll('[data-mobile-dropdown]');
  mobileDropdowns.forEach(function(item) {
    const submenuToggle = item.querySelector('.dl-navigation-mobile-menu__submenu-toggle');
    const submenu = item.querySelector('.dl-navigation-mobile-menu__submenu');
    if (!submenuToggle || !submenu) {
      return;
    }
    submenuToggle.addEventListener('click', function() {
      const isOpen = item.classList.toggle('is-open');
      submenuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen) {
        submenu.removeAttribute('inert');
        submenu.style.maxHeight = submenu.scrollHeight + 'px';
      } else {
        submenu.style.maxHeight = '';
        submenu.setAttribute('inert', '');
      }
    });
  });
  
  // Handle escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && mobileMenu.getAttribute('aria-hidden') === 'false') {
      closeMobileMenu();
    }
  });
  
  // Search Overlay
  const searchOverlay = document.querySelector('.dl-search-overlay');
  const searchTriggers = document.querySelectorAll('a[href*="search"]');
  const searchClose = document.querySelector('.dl-search-overlay__close');
  const searchBackdrop = document.querySelector('.dl-search-overlay__backdrop');
  const searchInput = document.querySelector('[data-search-input]');
  const searchResults = document.querySelector('[data-search-results]');
  const searchResultsInner = document.querySelector('.dl-search-overlay__results-inner');
  const searchSuggestions = document.querySelector('.dl-search-overlay__suggestions');
  let searchDebounceTimer;
  
  // Open search overlay
  function openSearchOverlay(e) {
    if (e) e.preventDefault();
    searchOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    
    // Focus on input after animation
    setTimeout(function() {
      searchInput.focus();
    }, 300);
  }
  
  // Close search overlay
  function closeSearchOverlay() {
    searchOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    searchInput.value = '';
    searchResults.classList.remove('active');
    searchSuggestions.style.display = '';
    searchResultsInner.innerHTML = '';
  }
  
  // Perform search
  async function performSearch(query) {
    if (query.length < 2) {
      searchResults.classList.remove('active');
      searchSuggestions.style.display = '';
      return;
    }
    
    // Hide suggestions, show results container
    searchSuggestions.style.display = 'none';
    searchResults.classList.add('active');
    
    // Show loading state
    searchResultsInner.innerHTML = `
      <div class="dl-search-overlay__loading">
        <div class="dl-search-overlay__loading-spinner"></div>
        <p>Searching...</p>
      </div>
    `;
    
    try {
      // Fetch search results from Shopify
      const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10`);
      const data = await response.json();
      
      if (data.resources.results.products && data.resources.results.products.length > 0) {
        // Display results
        let resultsHTML = '';
        data.resources.results.products.forEach(function(product) {
          const price = formatMoney(product.price, window.shopifyMoneyFormat);
          
          resultsHTML += `
            <a href="${product.url}" class="dl-search-result-item">
              ${product.image ? `
                <div class="dl-search-result-item__image">
                  <img src="${product.image}" alt="${product.title}">
                </div>
              ` : ''}
              <div class="dl-search-result-item__content">
                <h3 class="dl-search-result-item__title">${product.title}</h3>
                <p class="dl-search-result-item__price">${price}</p>
              </div>
            </a>
          `;
        });
        
        searchResultsInner.innerHTML = resultsHTML;
      } else {
        // No results found
        searchResultsInner.innerHTML = `
          <div class="dl-search-overlay__no-results">
            <p>No products found for "${query}"</p>
            <p>Try different keywords or browse our collections</p>
          </div>
        `;
      }
    } catch (error) {
      console.error('Search error:', error);
      searchResultsInner.innerHTML = `
        <div class="dl-search-overlay__no-results">
          <p>Something went wrong. Please try again.</p>
        </div>
      `;
    }
  }
  
  // Search input handler with debounce
  if (searchInput) {
    searchInput.addEventListener('input', function(e) {
      clearTimeout(searchDebounceTimer);
      searchDebounceTimer = setTimeout(function() {
        performSearch(e.target.value.trim());
      }, 300);
    });
  }
  
  // Event listeners for search overlay
  searchTriggers.forEach(function(trigger) {
    trigger.addEventListener('click', openSearchOverlay);
  });
  
  if (searchClose) {
    searchClose.addEventListener('click', closeSearchOverlay);
  }
  
  if (searchBackdrop) {
    searchBackdrop.addEventListener('click', closeSearchOverlay);
  }
  
  // Handle escape key for search
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && searchOverlay.getAttribute('aria-hidden') === 'false') {
      closeSearchOverlay();
    }
  });
  
  // Initial check
  handleScroll();

  // Global cart update listener
  window.addEventListener('cartUpdated', function(e) {
    if (e.detail && e.detail.cart) {
      const cartData = e.detail.cart;

      // Use the updateCartUI function to update everything including cart items
      updateCartUI(cartData);
    }
  });

  // Cart Slideover
  const cartSlideover = document.querySelector('.dl-cart-slideover');
  const cartToggle = document.querySelector('.dl-navigation-top__cart-toggle');
  const cartClose = document.querySelector('.dl-cart-slideover__close');
  const cartOverlay = document.querySelector('.dl-cart-slideover__overlay');
  const cartItems = document.querySelector('.dl-cart-slideover__items');

  // Open cart slideover
  function openCartSlideover(e) {
    if (e) e.preventDefault();
    cartSlideover.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  // Close cart slideover
  function closeCartSlideover() {
    cartSlideover.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // Update cart item quantity without page reload
  async function updateCartItemQuantity(key, quantity) {
    // Show loading state for the specific item
    const cartItem = document.querySelector(`[data-cart-item="${key}"]`);
    if (cartItem) {
      cartItem.style.opacity = '0.5';
      cartItem.style.pointerEvents = 'none';
    }

    try {
      // Get the line index for this item key
      const input = document.querySelector(`[data-item-key="${key}"]`);
      const lineIndex = input ? parseInt(input.dataset.lineIndex) : null;

      if (!lineIndex) {
        throw new Error('Unable to find item line index');
      }

      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line: lineIndex,
          quantity: quantity
        })
      });

      if (response.ok) {
        const cartData = await response.json();

        // Update the UI dynamically
        updateCartUI(cartData);

        // Dispatch global cart update event
        window.dispatchEvent(new CustomEvent('cartUpdated', {
          detail: { cart: cartData }
        }));
      }
    } catch (error) {
      console.error('Error updating cart:', error);

      // Show error message
      alert('There was an error updating your cart. Please try again.');
    } finally {
      // Remove loading state
      if (cartItem) {
        cartItem.style.opacity = '';
        cartItem.style.pointerEvents = '';
      }
    }
  }

  function updateCartFooter(cartData) {
    const cartFooter = document.querySelector('.dl-cart-slideover__footer');
    const subtotalPrice = document.querySelector('.dl-cart-slideover__subtotal-price');
    const shippingNotice = document.querySelector('.dl-cart-slideover__shipping-notice');
    const freeShippingThreshold = 10000; // $100 in cents

    if (!cartFooter || !subtotalPrice || !shippingNotice) {
      return;
    }

    const hasItems = cartData.item_count > 0;
    const remainingForFreeShipping = freeShippingThreshold - cartData.total_price;
    const progressWidth = Math.min((cartData.total_price * 100) / freeShippingThreshold, 100);

    cartFooter.style.display = hasItems ? '' : 'none';
    cartFooter.setAttribute('aria-hidden', hasItems ? 'false' : 'true');
    subtotalPrice.textContent = formatMoney(cartData.total_price, window.shopifyMoneyFormat);

    if (remainingForFreeShipping > 0) {
      const formattedRemaining = formatMoney(remainingForFreeShipping, window.shopifyMoneyFormat);

      shippingNotice.className = 'dl-cart-slideover__shipping-notice';
      shippingNotice.innerHTML = `
        <p>Add ${formattedRemaining} more for free shipping</p>
        <div class="dl-cart-slideover__shipping-progress">
          <div class="dl-cart-slideover__shipping-progress-bar" style="width: ${progressWidth}%"></div>
        </div>
      `;
    } else {
      shippingNotice.className = 'dl-cart-slideover__shipping-notice dl-cart-slideover__shipping-notice--success';
      shippingNotice.innerHTML = `
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <p>You qualify for free shipping!</p>
      `;
    }
  }

  // Update cart UI without page reload
  function updateCartUI(cartData) {
    // Update cart count in header
    const cartToggle = document.querySelector('.dl-navigation-top__cart-toggle');

    if (cartToggle) {
      // Remove existing count badge
      const existingBadge = cartToggle.querySelector('.dl-navigation-top__cart-count');
      if (existingBadge) {
        existingBadge.remove();
      }

      // Add new count badge if cart has items
      if (cartData.item_count > 0) {
        const countBadge = document.createElement('span');
        countBadge.className = 'dl-navigation-top__cart-count';
        countBadge.textContent = cartData.item_count;
        cartToggle.appendChild(countBadge);
      }
    }

    // Update cart slideover title
    const slideoverTitle = document.querySelector('.dl-cart-slideover__title');
    if (slideoverTitle) {
      slideoverTitle.textContent = `Shopping Bag (${cartData.item_count})`;
    }

    // Rebuild cart items container
    const cartItemsContainer = document.querySelector('.dl-cart-slideover__items');

    // DL-2331: cart.js does not expose product metafields, so the JS rebuild cannot read
    // `dl_product_subtitle` directly. Maintain a tiny handle → flavour map for products
    // whose only variant is the default one but whose customer-facing label includes a
    // flavour suffix. Keep this in sync with the same metafield in Admin (Products →
    // The Lip Film – Natural / – Strawberry & Mint → Metafields → `custom.dl_product_subtitle`).
    const LIP_FILM_FLAVOURS = {
      'the-lip-film-natural': 'Natural',
      'the-lip-film-strawberry-and-mint': 'Strawberry and Mint'
    };

    if (cartItemsContainer) {
      if (cartData.item_count > 0) {
        // Build HTML for all cart items
        let cartItemsHTML = '';
        cartData.items.forEach((item, index) => {
          const variantOrFlavour = item.variant_title || LIP_FILM_FLAVOURS[item.handle] || '';
          cartItemsHTML += `
            <div class="dl-cart-item" data-cart-item="${item.key}">
              <a href="${item.url}" class="dl-cart-item__image">
                <img src="${item.image}"
                     alt="${item.title}"
                     loading="lazy"
                     width="90"
                     height="90">
              </a>

              <div class="dl-cart-item__details">
                <h3 class="dl-cart-item__title">
                  <a href="${item.url}">${item.product_title || item.title}</a>
                </h3>
                ${variantOrFlavour ? `<p class="dl-cart-item__variant">${variantOrFlavour}</p>` : ''}

                <div class="dl-cart-item__quantity">
                  <button type="button" class="dl-cart-item__quantity-btn" data-quantity-decrease aria-label="Decrease quantity">
                    <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 1H12" stroke="currentColor" stroke-width="1"/>
                    </svg>
                  </button>
                  <input type="number"
                         class="dl-cart-item__quantity-input"
                         value="${item.quantity}"
                         min="0"
                         aria-label="Quantity"
                         data-item-key="${item.key}"
                         data-line-index="${index + 1}">
                  <button type="button" class="dl-cart-item__quantity-btn" data-quantity-increase aria-label="Increase quantity">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6 0V12" stroke="currentColor" stroke-width="1"/>
                      <path d="M0 6H12" stroke="currentColor" stroke-width="1"/>
                    </svg>
                  </button>
                </div>
              </div>

              <div class="dl-cart-item__actions">
                <p class="dl-cart-item__price">${formatMoney(item.final_line_price, window.shopifyMoneyFormat)}</p>
                <button type="button" class="dl-cart-item__remove" data-remove-item="${item.key}" aria-label="Remove item">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 6h18" stroke="currentColor" stroke-width="1" stroke-linecap="round"/>
                    <path d="M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2" stroke="currentColor" stroke-width="1" stroke-linecap="round"/>
                    <path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6" stroke="currentColor" stroke-width="1" stroke-linecap="round"/>
                    <path d="M10 11v6" stroke="currentColor" stroke-width="1" stroke-linecap="round"/>
                    <path d="M14 11v6" stroke="currentColor" stroke-width="1" stroke-linecap="round"/>
                  </svg>
                </button>
              </div>
            </div>
          `;
        });

        cartItemsContainer.innerHTML = cartItemsHTML;

        // Re-attach event listeners to the new elements
        attachCartItemEventListeners();
      } else {
        // Cart is empty
        cartItemsContainer.innerHTML = `
          <div class="dl-cart-slideover__empty">
            <svg width="64" height="64" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21.2246 4.80359V8.33289C21.2246 10.7899 21.4497 13.2419 21.8955 15.6581L23.1953 22.705C23.3795 23.7035 22.613 24.6246 21.5977 24.6249H2.40234C1.38699 24.6246 0.620455 23.7035 0.804688 22.705L2.10449 15.6581C2.55028 13.2419 2.77537 10.7899 2.77539 8.33289V4.80359H21.2246Z" stroke="currentColor" stroke-width="0.5" opacity="0.5"/>
              <path d="M17.1426 7.85714V3C17.1426 1.89543 16.2472 1 15.1426 1H8.85693C7.75236 1 6.85693 1.89543 6.85693 3V7.85714" stroke="currentColor" stroke-width="0.5" opacity="0.5"/>
            </svg>
            <p>Your shopping bag is empty</p>
            <a href="/collections/all" class="button button--primary">Start Shopping</a>
          </div>
        `;
      }
    }

    updateCartFooter(cartData);
  }

  // Remove cart item
  async function removeCartItem(key) {
    await updateCartItemQuantity(key, 0);
  }

  // Function to attach event listeners to cart items
  function attachCartItemEventListeners() {
    // Debounce timer for quantity inputs
    let quantityDebounceTimer = {};

    // Quantity decrease buttons
    document.querySelectorAll('[data-quantity-decrease]').forEach(button => {
      button.addEventListener('click', async function() {
        const input = this.nextElementSibling;
        const currentValue = parseInt(input.value);
        if (currentValue > 1) {
          input.value = currentValue - 1;

          const itemKey = input.dataset.itemKey;
          if (quantityDebounceTimer[itemKey]) {
            clearTimeout(quantityDebounceTimer[itemKey]);
          }

          await updateCartItemQuantity(itemKey, currentValue - 1);
        }
      });
    });

    // Quantity increase buttons
    document.querySelectorAll('[data-quantity-increase]').forEach(button => {
      button.addEventListener('click', async function() {
        const input = this.previousElementSibling;
        const currentValue = parseInt(input.value);
        input.value = currentValue + 1;

        const itemKey = input.dataset.itemKey;
        if (quantityDebounceTimer[itemKey]) {
          clearTimeout(quantityDebounceTimer[itemKey]);
        }

        await updateCartItemQuantity(itemKey, currentValue + 1);
      });
    });

    // Quantity input direct change
    document.querySelectorAll('.dl-cart-item__quantity-input').forEach(input => {
      input.addEventListener('input', function() {
        const quantity = parseInt(this.value) || 0;
        const itemKey = this.dataset.itemKey;

        if (quantityDebounceTimer[itemKey]) {
          clearTimeout(quantityDebounceTimer[itemKey]);
        }

        quantityDebounceTimer[itemKey] = setTimeout(() => {
          if (quantity >= 0) {
            updateCartItemQuantity(itemKey, quantity);
          }
        }, 500);
      });

      input.addEventListener('keydown', function(e) {
        if ([46, 8, 9, 27, 13].indexOf(e.keyCode) !== -1 ||
            (e.keyCode === 65 && e.ctrlKey === true) ||
            (e.keyCode === 67 && e.ctrlKey === true) ||
            (e.keyCode === 86 && e.ctrlKey === true) ||
            (e.keyCode === 88 && e.ctrlKey === true)) {
          return;
        }
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
          e.preventDefault();
        }
      });
    });

    // Remove item buttons
    document.querySelectorAll('[data-remove-item]').forEach(button => {
      button.addEventListener('click', async function() {
        const itemKey = this.dataset.removeItem;
        if (confirm('Are you sure you want to remove this item from your cart?')) {
          await removeCartItem(itemKey);
        }
      });
    });
  }

  // Event listeners for cart slideover
  if (cartToggle) {
    cartToggle.addEventListener('click', openCartSlideover);
  }

  if (cartClose) {
    cartClose.addEventListener('click', closeCartSlideover);
  }

  if (cartOverlay) {
    cartOverlay.addEventListener('click', closeCartSlideover);
  }

  // Attach event listeners for initial cart items on page load
  attachCartItemEventListeners();

  // Handle escape key for cart
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && cartSlideover && cartSlideover.getAttribute('aria-hidden') === 'false') {
      closeCartSlideover();
    }
  });
  
  // Account Overlay
  const accountOverlay = document.querySelector('.dl-account-overlay');
  const accountToggle = document.querySelector('.dl-navigation-top__account-toggle');
  const accountClose = document.querySelector('.dl-account-overlay__close');
  const accountBackdrop = document.querySelector('.dl-account-overlay__backdrop');
  const accountEmailInput = document.querySelector('#CustomerEmail');
  
  // Open account overlay
  function openAccountOverlay(e) {
    if (e) e.preventDefault();
    accountOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    
    // Focus on email input if logged out, or close button if logged in
    setTimeout(function() {
      if (accountEmailInput) {
        accountEmailInput.focus();
      } else {
        accountClose.focus();
      }
    }, 300);
  }
  
  // Close account overlay
  function closeAccountOverlay() {
    accountOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  
  // Event listeners for account overlay
  if (accountToggle) {
    accountToggle.addEventListener('click', openAccountOverlay);
  }
  
  if (accountClose) {
    accountClose.addEventListener('click', closeAccountOverlay);
  }
  
  if (accountBackdrop) {
    accountBackdrop.addEventListener('click', closeAccountOverlay);
  }
  
  // Handle escape key for account
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && accountOverlay && accountOverlay.getAttribute('aria-hidden') === 'false') {
      closeAccountOverlay();
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dl-navigation-top"] && !Shopify.designMode) return;
  try {
    
// Helper function to format money using Shopify's format
function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || '${{amount}}';

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision || 2;
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(number) || number === null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  const match = formatString.match(placeholderRegex);
  if (!match) {
    // If format doesn't match expected pattern, return a simple formatted number
    return formatString.replace(/\d+/, (cents / 100.0).toFixed(2));
  }

  switch (match[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'", '.');
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }

  return formatString.replace(placeholderRegex, value);
}

document.addEventListener('DOMContentLoaded', function() {
  const nav = document.querySelector('.dl-navigation-top');
  const mobileMenu = document.querySelector('.dl-navigation-mobile-menu');
  const menuToggle = document.querySelector('.dl-navigation-top__menu-toggle');
  const menuClose = document.querySelector('.dl-navigation-mobile-menu__close');
  const menuOverlay = document.querySelector('.dl-navigation-mobile-menu__overlay');
  const menuLinks = document.querySelectorAll('.dl-navigation-mobile-menu__links a');
  let lastScrollTop = 0;
  
  // Handle scroll events for background color change
  function handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > 50) {
      nav.classList.add('dl-navigation-top--scrolled');

      // Force SVG colors to #333 using inline styles (overrides !important CSS)
      // Target logo, menu toggle, and action icons specifically
      const logoSvg = nav.querySelectorAll('.dl-navigation-top__logo svg, .dl-navigation-top__logo svg *');
      const menuSvg = nav.querySelectorAll('.dl-navigation-top__menu-toggle svg, .dl-navigation-top__menu-toggle svg *');
      const actionsSvg = nav.querySelectorAll('.dl-navigation-top__actions svg, .dl-navigation-top__actions svg *');

      const allSvgElements = [...logoSvg, ...menuSvg, ...actionsSvg];

      allSvgElements.forEach(el => {
        const tagName = el.tagName.toLowerCase();

        // Check if element is inside action icons (should remain hollow/stroked)
        const isInCart = el.closest('.dl-navigation-top__cart-toggle');
        const isInAccount = el.closest('.dl-navigation-top__account-toggle');
        const isInSearch = el.closest('.dl-navigation-top__search-toggle');

        // Use inline styles which override CSS !important
        if (['path', 'rect', 'circle', 'polygon', 'ellipse'].includes(tagName)) {
          if (isInCart || isInAccount || isInSearch) {
            // For cart, account, and search icons, use stroke instead of fill to keep them hollow
            el.style.setProperty('stroke', '#333', 'important');
            el.style.setProperty('fill', 'none', 'important');
          } else {
            // For logo and other filled icons
            // el.style.setProperty('fill', '#333', 'important'); // Removed fill for now since search icon on scroll has black fill.
            el.style.setProperty('color', '#333', 'important');
          }
        }

        if (['line', 'polyline'].includes(tagName)) {
          el.style.setProperty('stroke', '#333', 'important');
        }

        if (tagName === 'svg') {
          el.style.setProperty('color', '#333', 'important');
        }
      });
    } else {
      nav.classList.remove('dl-navigation-top--scrolled');

      // Remove forced inline styles when not scrolled
      const allSvgElements = nav.querySelectorAll('.dl-navigation-top__logo svg, .dl-navigation-top__logo svg *, .dl-navigation-top__menu-toggle svg, .dl-navigation-top__menu-toggle svg *, .dl-navigation-top__actions svg, .dl-navigation-top__actions svg *');
      allSvgElements.forEach(el => {
        el.style.removeProperty('fill');
        el.style.removeProperty('stroke');
        el.style.removeProperty('color');
      });
    }

    lastScrollTop = scrollTop;
  }
  
  // Throttle scroll events for performance
  let scrollTimer;
  window.addEventListener('scroll', function() {
    if (scrollTimer) {
      clearTimeout(scrollTimer);
    }
    scrollTimer = setTimeout(handleScroll, 10);
  });
  
  // Mobile menu toggle functions
  function openMobileMenu() {
    mobileMenu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    
    // Trap focus in menu
    menuClose.focus();
  }
  
  function closeMobileMenu() {
    mobileMenu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    
    // Return focus to toggle button
    menuToggle.focus();
  }
  
  // Event listeners for mobile menu
  if (menuToggle) {
    menuToggle.addEventListener('click', openMobileMenu);
  }
  
  if (menuClose) {
    menuClose.addEventListener('click', closeMobileMenu);
  }
  
  if (menuOverlay) {
    menuOverlay.addEventListener('click', closeMobileMenu);
  }
  
  // Close menu when clicking on a link (optional - remove if you want menu to stay open)
  menuLinks.forEach(function(link) {
    link.addEventListener('click', function() {
      // Only close on mobile
      if (window.innerWidth < 900) {
        closeMobileMenu();
      }
    });
  });

  // Shop dropdown (desktop) + accordion (mobile) - DL-3009
  const shopDropdowns = document.querySelectorAll('[data-dropdown]');
  shopDropdowns.forEach(function(dropdown) {
    const toggle = dropdown.querySelector('.dl-navigation-top__dropdown-toggle');
    if (!toggle) {
      return;
    }
    let suppressFocusOpen = false;

    function setOpen(isOpen) {
      dropdown.classList.toggle('is-open', isOpen);
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    // Touch/pen: the focus that follows a tap must not pre-open the menu, or the
    // first tap would navigate instead of opening. Suppress focus-open for it.
    dropdown.addEventListener('pointerdown', function(event) {
      if (event.pointerType !== 'mouse') {
        suppressFocusOpen = true;
      }
    });
    dropdown.addEventListener('pointerup', function() {
      window.setTimeout(function() {
        suppressFocusOpen = false;
      }, 0);
    });

    // Mouse hover opens/closes; touch is handled by the click below so the first
    // tap opens rather than navigating
    dropdown.addEventListener('pointerenter', function(event) {
      if (event.pointerType === 'mouse') {
        setOpen(true);
      }
    });
    dropdown.addEventListener('pointerleave', function(event) {
      if (event.pointerType === 'mouse' && !dropdown.contains(document.activeElement)) {
        setOpen(false);
      }
    });

    // Keyboard focus opens; leaving the group closes
    dropdown.addEventListener('focusin', function() {
      if (!suppressFocusOpen) {
        setOpen(true);
      }
    });
    dropdown.addEventListener('focusout', function(event) {
      if (!dropdown.contains(event.relatedTarget)) {
        setOpen(false);
      }
    });

    // First tap/click opens the menu (when closed) instead of following the link;
    // a second interaction (already open) navigates to All Products
    toggle.addEventListener('click', function(event) {
      if (toggle.getAttribute('aria-expanded') !== 'true') {
        event.preventDefault();
        setOpen(true);
      }
    });

    // Escape closes and restores focus to the toggle without immediately reopening
    dropdown.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        setOpen(false);
        suppressFocusOpen = true;
        toggle.focus();
        window.setTimeout(function() {
          suppressFocusOpen = false;
        }, 0);
      }
    });
  });

  // Close an open desktop dropdown when clicking outside it
  if (shopDropdowns.length) {
    document.addEventListener('click', function(event) {
      shopDropdowns.forEach(function(dropdown) {
        if (!dropdown.contains(event.target)) {
          dropdown.classList.remove('is-open');
          const outsideToggle = dropdown.querySelector('.dl-navigation-top__dropdown-toggle');
          if (outsideToggle) {
            outsideToggle.setAttribute('aria-expanded', 'false');
          }
        }
      });
    });
  }

  // Mobile slide-out Shop accordion; `inert` keeps collapsed links out of the tab
  // order and off assistive tech
  const mobileDropdowns = document.querySelectorAll('[data-mobile-dropdown]');
  mobileDropdowns.forEach(function(item) {
    const submenuToggle = item.querySelector('.dl-navigation-mobile-menu__submenu-toggle');
    const submenu = item.querySelector('.dl-navigation-mobile-menu__submenu');
    if (!submenuToggle || !submenu) {
      return;
    }
    submenuToggle.addEventListener('click', function() {
      const isOpen = item.classList.toggle('is-open');
      submenuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen) {
        submenu.removeAttribute('inert');
        submenu.style.maxHeight = submenu.scrollHeight + 'px';
      } else {
        submenu.style.maxHeight = '';
        submenu.setAttribute('inert', '');
      }
    });
  });
  
  // Handle escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && mobileMenu.getAttribute('aria-hidden') === 'false') {
      closeMobileMenu();
    }
  });
  
  // Search Overlay
  const searchOverlay = document.querySelector('.dl-search-overlay');
  const searchTriggers = document.querySelectorAll('a[href*="search"]');
  const searchClose = document.querySelector('.dl-search-overlay__close');
  const searchBackdrop = document.querySelector('.dl-search-overlay__backdrop');
  const searchInput = document.querySelector('[data-search-input]');
  const searchResults = document.querySelector('[data-search-results]');
  const searchResultsInner = document.querySelector('.dl-search-overlay__results-inner');
  const searchSuggestions = document.querySelector('.dl-search-overlay__suggestions');
  let searchDebounceTimer;
  
  // Open search overlay
  function openSearchOverlay(e) {
    if (e) e.preventDefault();
    searchOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    
    // Focus on input after animation
    setTimeout(function() {
      searchInput.focus();
    }, 300);
  }
  
  // Close search overlay
  function closeSearchOverlay() {
    searchOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    searchInput.value = '';
    searchResults.classList.remove('active');
    searchSuggestions.style.display = '';
    searchResultsInner.innerHTML = '';
  }
  
  // Perform search
  async function performSearch(query) {
    if (query.length < 2) {
      searchResults.classList.remove('active');
      searchSuggestions.style.display = '';
      return;
    }
    
    // Hide suggestions, show results container
    searchSuggestions.style.display = 'none';
    searchResults.classList.add('active');
    
    // Show loading state
    searchResultsInner.innerHTML = `
      <div class="dl-search-overlay__loading">
        <div class="dl-search-overlay__loading-spinner"></div>
        <p>Searching...</p>
      </div>
    `;
    
    try {
      // Fetch search results from Shopify
      const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10`);
      const data = await response.json();
      
      if (data.resources.results.products && data.resources.results.products.length > 0) {
        // Display results
        let resultsHTML = '';
        data.resources.results.products.forEach(function(product) {
          const price = formatMoney(product.price, window.shopifyMoneyFormat);
          
          resultsHTML += `
            <a href="${product.url}" class="dl-search-result-item">
              ${product.image ? `
                <div class="dl-search-result-item__image">
                  <img src="${product.image}" alt="${product.title}">
                </div>
              ` : ''}
              <div class="dl-search-result-item__content">
                <h3 class="dl-search-result-item__title">${product.title}</h3>
                <p class="dl-search-result-item__price">${price}</p>
              </div>
            </a>
          `;
        });
        
        searchResultsInner.innerHTML = resultsHTML;
      } else {
        // No results found
        searchResultsInner.innerHTML = `
          <div class="dl-search-overlay__no-results">
            <p>No products found for "${query}"</p>
            <p>Try different keywords or browse our collections</p>
          </div>
        `;
      }
    } catch (error) {
      console.error('Search error:', error);
      searchResultsInner.innerHTML = `
        <div class="dl-search-overlay__no-results">
          <p>Something went wrong. Please try again.</p>
        </div>
      `;
    }
  }
  
  // Search input handler with debounce
  if (searchInput) {
    searchInput.addEventListener('input', function(e) {
      clearTimeout(searchDebounceTimer);
      searchDebounceTimer = setTimeout(function() {
        performSearch(e.target.value.trim());
      }, 300);
    });
  }
  
  // Event listeners for search overlay
  searchTriggers.forEach(function(trigger) {
    trigger.addEventListener('click', openSearchOverlay);
  });
  
  if (searchClose) {
    searchClose.addEventListener('click', closeSearchOverlay);
  }
  
  if (searchBackdrop) {
    searchBackdrop.addEventListener('click', closeSearchOverlay);
  }
  
  // Handle escape key for search
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && searchOverlay.getAttribute('aria-hidden') === 'false') {
      closeSearchOverlay();
    }
  });
  
  // Initial check
  handleScroll();

  // Global cart update listener
  window.addEventListener('cartUpdated', function(e) {
    if (e.detail && e.detail.cart) {
      const cartData = e.detail.cart;

      // Use the updateCartUI function to update everything including cart items
      updateCartUI(cartData);
    }
  });

  // Cart Slideover
  const cartSlideover = document.querySelector('.dl-cart-slideover');
  const cartToggle = document.querySelector('.dl-navigation-top__cart-toggle');
  const cartClose = document.querySelector('.dl-cart-slideover__close');
  const cartOverlay = document.querySelector('.dl-cart-slideover__overlay');
  const cartPanel = document.querySelector('.dl-cart-slideover__panel');
  const cartItems = document.querySelector('.dl-cart-slideover__items');
  let cartReturnFocus = null;

  function getCartFocusableElements() {
    if (!cartSlideover) {
      return [];
    }

    return Array.from(cartSlideover.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function(element) {
      return !element.hidden && element.getAttribute('aria-hidden') !== 'true' && element.offsetParent !== null;
    });
  }
  
  // Open cart slideover
  function openCartSlideover(e) {
    if (e) e.preventDefault();
    cartReturnFocus = e && e.currentTarget ? e.currentTarget : cartToggle;
    cartSlideover.removeAttribute('inert');
    cartSlideover.setAttribute('aria-hidden', 'false');
    if (cartToggle) {
      cartToggle.setAttribute('aria-expanded', 'true');
    }
    document.body.style.overflow = 'hidden';

    window.requestAnimationFrame(function() {
      const initialFocus = cartClose || cartPanel;
      if (initialFocus) {
        initialFocus.focus({ preventScroll: true });
      }
    });
  }
  
  // Close cart slideover
  function closeCartSlideover() {
    cartSlideover.setAttribute('aria-hidden', 'true');
    cartSlideover.setAttribute('inert', '');
    if (cartToggle) {
      cartToggle.setAttribute('aria-expanded', 'false');
    }
    document.body.style.overflow = '';

    const returnTarget = cartReturnFocus || cartToggle;
    cartReturnFocus = null;
    if (returnTarget && document.contains(returnTarget)) {
      window.requestAnimationFrame(function() {
        returnTarget.focus({ preventScroll: true });
      });
    }
  }
  
  // Update cart item quantity without page reload
  async function updateCartItemQuantity(key, quantity) {
    // Show loading state for the specific item
    const cartItem = document.querySelector(`[data-cart-item="${key}"]`);
    if (cartItem) {
      cartItem.style.opacity = '0.5';
      cartItem.style.pointerEvents = 'none';
    }

    try {
      // Get the line index for this item key
      const input = document.querySelector(`[data-item-key="${key}"]`);
      const lineIndex = input ? parseInt(input.dataset.lineIndex) : null;

      if (!lineIndex) {
        throw new Error('Unable to find item line index');
      }

      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line: lineIndex,
          quantity: quantity
        })
      });

      if (response.ok) {
        const cartData = await response.json();

        // Update the UI dynamically
        updateCartUI(cartData);

        // Dispatch global cart update event
        window.dispatchEvent(new CustomEvent('cartUpdated', {
          detail: { cart: cartData }
        }));
      } else {
        throw new Error('Cart update failed');
      }
    } catch (error) {
      console.error('Error updating cart:', error);

      // Show error message
      alert('There was an error updating your cart. Please try again.');
    } finally {
      // Remove loading state
      if (cartItem) {
        cartItem.style.opacity = '';
        cartItem.style.pointerEvents = '';
      }
    }
  }

  function updateCartFooter(cartData) {
    const cartFooter = document.querySelector('.dl-cart-slideover__footer');
    const subtotalPrice = document.querySelector('.dl-cart-slideover__subtotal-price');
    const shippingNotice = document.querySelector('.dl-cart-slideover__shipping-notice');
    const freeShippingThreshold = 10000; // $100 in cents

    if (!cartFooter || !subtotalPrice || !shippingNotice) {
      return;
    }

    const hasItems = cartData.item_count > 0;
    const remainingForFreeShipping = freeShippingThreshold - cartData.total_price;
    const progressWidth = Math.min((cartData.total_price * 100) / freeShippingThreshold, 100);

    cartFooter.style.display = hasItems ? '' : 'none';
    cartFooter.setAttribute('aria-hidden', hasItems ? 'false' : 'true');
    subtotalPrice.textContent = formatMoney(cartData.total_price, window.shopifyMoneyFormat);

    if (remainingForFreeShipping > 0) {
      const formattedRemaining = formatMoney(remainingForFreeShipping, window.shopifyMoneyFormat);

      shippingNotice.className = 'dl-cart-slideover__shipping-notice';
      shippingNotice.innerHTML = `
        <p>Add ${formattedRemaining} more for free shipping</p>
        <div class="dl-cart-slideover__shipping-progress">
          <div class="dl-cart-slideover__shipping-progress-bar" style="width: ${progressWidth}%"></div>
        </div>
      `;
    } else {
      shippingNotice.className = 'dl-cart-slideover__shipping-notice dl-cart-slideover__shipping-notice--success';
      shippingNotice.innerHTML = `
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <p>You qualify for free shipping!</p>
      `;
    }
  }

  // Update cart UI without page reload
  function updateCartUI(cartData) {
    // Update cart count in header
    const cartToggle = document.querySelector('.dl-navigation-top__cart-toggle');

    if (cartToggle) {
      // Remove existing count badge
      const existingBadge = cartToggle.querySelector('.dl-navigation-top__cart-count');
      if (existingBadge) {
        existingBadge.remove();
      }

      // Add new count badge if cart has items
      if (cartData.item_count > 0) {
        const countBadge = document.createElement('span');
        countBadge.className = 'dl-navigation-top__cart-count';
        countBadge.textContent = cartData.item_count;
        cartToggle.appendChild(countBadge);
      }
    }

    // Update cart slideover title
    const slideoverTitle = document.querySelector('.dl-cart-slideover__title');
    if (slideoverTitle) {
      slideoverTitle.textContent = `Shopping Bag (${cartData.item_count})`;
    }

    // Rebuild cart items container
    const cartItemsContainer = document.querySelector('.dl-cart-slideover__items');

    // DL-2331: cart.js does not expose product metafields, so the JS rebuild cannot read
    // `dl_product_subtitle` directly. Maintain a tiny handle → flavour map for products
    // whose only variant is the default one but whose customer-facing label includes a
    // flavour suffix. Keep this in sync with the same metafield in Admin (Products →
    // The Lip Film – Natural / – Strawberry & Mint → Metafields → `custom.dl_product_subtitle`).
    const LIP_FILM_FLAVOURS = {
      'the-lip-film-natural': 'Natural',
      'the-lip-film-strawberry-and-mint': 'Strawberry and Mint'
    };

    if (cartItemsContainer) {
      if (cartData.item_count > 0) {
        // Build HTML for all cart items
        let cartItemsHTML = '';
        cartData.items.forEach((item, index) => {
          const variantOrFlavour = item.variant_title || LIP_FILM_FLAVOURS[item.handle] || '';
          cartItemsHTML += `
            <div class="dl-cart-item" data-cart-item="${item.key}">
              <a href="${item.url}" class="dl-cart-item__image">
                <img src="${item.image}"
                     alt="${item.title}"
                     loading="lazy"
                     width="90"
                     height="90">
              </a>

              <div class="dl-cart-item__details">
                <h3 class="dl-cart-item__title">
                  <a href="${item.url}">${item.product_title || item.title}</a>
                </h3>
                ${variantOrFlavour ? `<p class="dl-cart-item__variant">${variantOrFlavour}</p>` : ''}

                <div class="dl-cart-item__quantity">
                  <button type="button" class="dl-cart-item__quantity-btn" data-quantity-decrease aria-label="Decrease quantity">
                    <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 1H12" stroke="currentColor" stroke-width="1"/>
                    </svg>
                  </button>
                  <input type="number"
                         class="dl-cart-item__quantity-input"
                         value="${item.quantity}"
                         min="0"
                         aria-label="Quantity"
                         data-item-key="${item.key}"
                         data-line-index="${index + 1}">
                  <button type="button" class="dl-cart-item__quantity-btn" data-quantity-increase aria-label="Increase quantity">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6 0V12" stroke="currentColor" stroke-width="1"/>
                      <path d="M0 6H12" stroke="currentColor" stroke-width="1"/>
                    </svg>
                  </button>
                </div>
              </div>

              <div class="dl-cart-item__actions">
                <p class="dl-cart-item__price">${formatMoney(item.final_line_price, window.shopifyMoneyFormat)}</p>
                <button type="button" class="dl-cart-item__remove" data-remove-item="${item.key}" aria-label="Remove item">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 6h18" stroke="currentColor" stroke-width="1" stroke-linecap="round"/>
                    <path d="M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2" stroke="currentColor" stroke-width="1" stroke-linecap="round"/>
                    <path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6" stroke="currentColor" stroke-width="1" stroke-linecap="round"/>
                    <path d="M10 11v6" stroke="currentColor" stroke-width="1" stroke-linecap="round"/>
                    <path d="M14 11v6" stroke="currentColor" stroke-width="1" stroke-linecap="round"/>
                  </svg>
                </button>
              </div>
            </div>
          `;
        });

        cartItemsContainer.innerHTML = cartItemsHTML;

        // Re-attach event listeners to the new elements
        attachCartItemEventListeners();
      } else {
        // Cart is empty
        cartItemsContainer.innerHTML = `
          <div class="dl-cart-slideover__empty">
            <svg width="64" height="64" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21.2246 4.80359V8.33289C21.2246 10.7899 21.4497 13.2419 21.8955 15.6581L23.1953 22.705C23.3795 23.7035 22.613 24.6246 21.5977 24.6249H2.40234C1.38699 24.6246 0.620455 23.7035 0.804688 22.705L2.10449 15.6581C2.55028 13.2419 2.77537 10.7899 2.77539 8.33289V4.80359H21.2246Z" stroke="currentColor" stroke-width="0.5" opacity="0.5"/>
              <path d="M17.1426 7.85714V3C17.1426 1.89543 16.2472 1 15.1426 1H8.85693C7.75236 1 6.85693 1.89543 6.85693 3V7.85714" stroke="currentColor" stroke-width="0.5" opacity="0.5"/>
            </svg>
            <p>Your shopping bag is empty</p>
            <a href="/collections/all" class="button button--primary">Start Shopping</a>
          </div>
        `;
      }
    }

    updateCartFooter(cartData);
  }

  // Remove cart item
  async function removeCartItem(key) {
    await updateCartItemQuantity(key, 0);
  }

  // Function to attach event listeners to cart items
  function attachCartItemEventListeners() {
    // Debounce timer for quantity inputs
    let quantityDebounceTimer = {};

    // Quantity decrease buttons
    document.querySelectorAll('[data-quantity-decrease]').forEach(button => {
      button.addEventListener('click', async function() {
        const input = this.nextElementSibling;
        const currentValue = parseInt(input.value);
        if (currentValue > 1) {
          input.value = currentValue - 1;

          const itemKey = input.dataset.itemKey;
          if (quantityDebounceTimer[itemKey]) {
            clearTimeout(quantityDebounceTimer[itemKey]);
          }

          await updateCartItemQuantity(itemKey, currentValue - 1);
        }
      });
    });

    // Quantity increase buttons
    document.querySelectorAll('[data-quantity-increase]').forEach(button => {
      button.addEventListener('click', async function() {
        const input = this.previousElementSibling;
        const currentValue = parseInt(input.value);
        input.value = currentValue + 1;

        const itemKey = input.dataset.itemKey;
        if (quantityDebounceTimer[itemKey]) {
          clearTimeout(quantityDebounceTimer[itemKey]);
        }

        await updateCartItemQuantity(itemKey, currentValue + 1);
      });
    });

    // Quantity input direct change
    document.querySelectorAll('.dl-cart-item__quantity-input').forEach(input => {
      input.addEventListener('input', function() {
        const quantity = parseInt(this.value) || 0;
        const itemKey = this.dataset.itemKey;

        if (quantityDebounceTimer[itemKey]) {
          clearTimeout(quantityDebounceTimer[itemKey]);
        }

        quantityDebounceTimer[itemKey] = setTimeout(() => {
          if (quantity >= 0) {
            updateCartItemQuantity(itemKey, quantity);
          }
        }, 500);
      });

      input.addEventListener('keydown', function(e) {
        if ([46, 8, 9, 27, 13].indexOf(e.keyCode) !== -1 ||
            (e.keyCode === 65 && e.ctrlKey === true) ||
            (e.keyCode === 67 && e.ctrlKey === true) ||
            (e.keyCode === 86 && e.ctrlKey === true) ||
            (e.keyCode === 88 && e.ctrlKey === true)) {
          return;
        }
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
          e.preventDefault();
        }
      });
    });

    // Remove item buttons
    document.querySelectorAll('[data-remove-item]').forEach(button => {
      button.addEventListener('click', async function() {
        const itemKey = this.dataset.removeItem;
        if (confirm('Are you sure you want to remove this item from your cart?')) {
          await removeCartItem(itemKey);
        }
      });
    });
  }

  // Event listeners for cart slideover
  if (cartToggle) {
    cartToggle.addEventListener('click', openCartSlideover);
  }

  if (cartClose) {
    cartClose.addEventListener('click', closeCartSlideover);
  }

  if (cartOverlay) {
    cartOverlay.addEventListener('click', closeCartSlideover);
  }

  // Checkout's /cart route hands off to the homepage with this one-time signal.
  const cartHandoffUrl = new URL(window.location.href);
  if (cartHandoffUrl.searchParams.get('open_cart') === '1') {
    openCartSlideover();
    cartHandoffUrl.searchParams.delete('open_cart');
    window.history.replaceState(
      window.history.state,
      '',
      cartHandoffUrl.pathname + cartHandoffUrl.search + cartHandoffUrl.hash
    );
  }

  // Attach event listeners for initial cart items on page load
  attachCartItemEventListeners();
  
  // Keep keyboard focus inside the open cart and support Escape to close.
  document.addEventListener('keydown', function(e) {
    if (!cartSlideover || cartSlideover.getAttribute('aria-hidden') !== 'false') {
      return;
    }

    if (e.key === 'Escape') {
      closeCartSlideover();
      return;
    }

    if (e.key !== 'Tab') {
      return;
    }

    const focusableElements = getCartFocusableElements();
    if (!focusableElements.length) {
      e.preventDefault();
      if (cartPanel) {
        cartPanel.focus();
      }
      return;
    }

    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];
    const focusIsOutsideCart = !cartSlideover.contains(document.activeElement);

    if (e.shiftKey && (document.activeElement === firstFocusable || focusIsOutsideCart)) {
      e.preventDefault();
      lastFocusable.focus();
    } else if (!e.shiftKey && (document.activeElement === lastFocusable || focusIsOutsideCart)) {
      e.preventDefault();
      firstFocusable.focus();
    }
  });
  
  // Account Overlay
  const accountOverlay = document.querySelector('.dl-account-overlay');
  const accountToggle = document.querySelector('.dl-navigation-top__account-toggle');
  const accountClose = document.querySelector('.dl-account-overlay__close');
  const accountBackdrop = document.querySelector('.dl-account-overlay__backdrop');
  const accountEmailInput = document.querySelector('#CustomerEmail');
  
  // Open account overlay
  function openAccountOverlay(e) {
    if (e) e.preventDefault();
    accountOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    
    // Focus on email input if logged out, or close button if logged in
    setTimeout(function() {
      if (accountEmailInput) {
        accountEmailInput.focus();
      } else {
        accountClose.focus();
      }
    }, 300);
  }
  
  // Close account overlay
  function closeAccountOverlay() {
    accountOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  
  // Event listeners for account overlay
  if (accountToggle) {
    accountToggle.addEventListener('click', openAccountOverlay);
  }
  
  if (accountClose) {
    accountClose.addEventListener('click', closeAccountOverlay);
  }
  
  if (accountBackdrop) {
    accountBackdrop.addEventListener('click', closeAccountOverlay);
  }
  
  // Handle escape key for account
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && accountOverlay && accountOverlay.getAttribute('aria-hidden') === 'false') {
      closeAccountOverlay();
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dl-product-showcase"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const showcaseSection = document.querySelector('.dl-product-showcase');
    if (!showcaseSection) return;
    
    // Wait for Swiper to be available
    if (typeof Swiper === 'undefined') {
        console.error('DL Product Showcase: Swiper library is not loaded');
        return;
    }
    
    // Initialize Primary Image Slider
    const primarySlider = showcaseSection.querySelector('[data-showcase-primary]');
    const navSlider = showcaseSection.querySelector('[data-showcase-nav]');
    
    let primarySwiper = null;
    let navSwiper = null;
    
    // Initialize Thumbnail Navigation First
    if (navSlider) {
        try {
            navSwiper = new Swiper(navSlider, {
                direction: 'vertical',
                slidesPerView: 3,
                spaceBetween: 16, // 1rem gap
                loop: false,
                freeMode: true,
                watchSlidesProgress: true,
                watchSlidesVisibility: true,
                breakpoints: {
                    // Tablet
                    768: {
                        direction: 'vertical',
                        slidesPerView: 3,
                        spaceBetween: 16
                    },
                    // Desktop
                    1024: {
                        direction: 'vertical',
                        slidesPerView: 3,
                        spaceBetween: 16
                    }
                }
            });
        } catch (error) {
            console.error('DL Product Showcase: Error initializing nav swiper:', error);
        }
    }
    
    // Initialize Primary Slider
    if (primarySlider) {
        try {
            primarySwiper = new Swiper(primarySlider, {
                spaceBetween: 10,
                loop: false,
                navigation: false,
                pagination: false,
                allowTouchMove: true,
                thumbs: navSwiper ? {
                    swiper: navSwiper
                } : null
            });
        } catch (error) {
            console.error('DL Product Showcase: Error initializing primary swiper:', error);
        }
    }
    
    // Handle thumbnail clicks manually as backup
    if (navSlider && primarySwiper) {
        const thumbnails = navSlider.querySelectorAll('.swiper-slide');
        thumbnails.forEach(function(thumb) {
            thumb.addEventListener('click', function() {
                const slideIndex = parseInt(this.dataset.slideIndex);
                
                // Update primary slider
                if (primarySwiper) {
                    primarySwiper.slideTo(slideIndex);
                }
                
                // Update active state
                thumbnails.forEach(t => t.classList.remove('active'));
                this.classList.add('active');
            });
        });
        
        // Sync active state when primary slider changes
        if (primarySwiper) {
            primarySwiper.on('slideChange', function() {
                const activeIndex = primarySwiper.activeIndex;
                thumbnails.forEach(function(thumb, index) {
                    if (index === activeIndex) {
                        thumb.classList.add('active');
                    } else {
                        thumb.classList.remove('active');
                    }
                });
            });
        }
    }
    
    // Handle Variant Options
    const variantOptions = showcaseSection.querySelectorAll('.dl-product-showcase__variant-option');
    const form = showcaseSection.querySelector('form');
    
    if (form) {
        variantOptions.forEach(function(option) {
            option.addEventListener('click', function() {
                if (this.disabled) return;
                
                const position = this.dataset.optionPosition;
                const value = this.dataset.optionValue;
                const price = this.dataset.optionPrice;
                const container = this.closest('.dl-product-showcase__variant-options');
                
                // Remove active from siblings
                container.querySelectorAll('.dl-product-showcase__variant-option').forEach(opt => {
                    opt.classList.remove('active');
                });
                
                // Add active to clicked
                this.classList.add('active');

                // Update specific dataset value(s) of the cart form.
                form.dataset.productPrice = price;
                
                // Update variant selection (simplified - you may need more complex logic for multi-option products)
                // This would typically involve finding the matching variant based on all selected options
                updateSelectedVariant();

                updateAddToCartButton(price);
            });
        });
    }
    
    function updateSelectedVariant() {
        // Get all selected options
        const selectedOptions = [];
        const variantIdInput = form?.querySelector('input[name="id"]');
        showcaseSection.querySelectorAll('.dl-product-showcase__variant-option.active').forEach(function(option) {
            selectedOptions.push(option.dataset.optionValue);
            variantIdInput.value = option.dataset.optionVariantId;
        });
        
        // Here you would typically match against product.variants to find the correct variant ID
        // This is simplified - in production you'd need the full variant data
    }
    
    // Update add to cart button text with selected variant price
    function updateAddToCartButton(price) {
        const button = showcaseSection.querySelector('.dl-product-showcase__add-to-cart');
        if (button && button.textContent.includes('Add to Bag')) {
            button.innerHTML = `
                <span class="button__text">
                    Add to Bag - ${price}
                </span>
                <span class="button__spinner" style="display: none;" aria-hidden="true">
                    <svg class="spinner" width="20" height="20" viewBox="0 0 48 48">
                        <circle cx="24" cy="24" r="20" stroke="currentColor" stroke-width="4" fill="none" stroke-linecap="round" stroke-dasharray="80, 60"/>
                    </svg>
                </span>
            `;
        }
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dl-product-slider-article"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Find all product slider sections on the page
  const sliderSections = document.querySelectorAll('.dl-product-slider');

  // Only run if sliders exist on the page
  if (sliderSections.length === 0) return;

  sliderSections.forEach(function(sliderElement) {
    const sectionId = sliderElement.dataset.sectionId;
    const swiperContainer = sliderElement.querySelector('.swiper');

    if (swiperContainer && typeof Swiper !== 'undefined') {
      const nextButton = sliderElement.querySelector('.dl-product-slider__button--next');
      const prevButton = sliderElement.querySelector('.dl-product-slider__button--prev');

      try {
        // Initialize Swiper for this specific instance
        const swiper = new Swiper(swiperContainer, {
          // Basic settings
          loop: false,
          spaceBetween: 20,


          // Responsive breakpoints
          breakpoints: {
            // Mobile: show 1.5 products
            320: {
              slidesPerView: 1.5,
            },
            // Tablet portrait
            768: {
              slidesPerView: 2,
            },
            // Tablet landscape and up: show 3 products
            1024: {
              slidesPerView: 3,
            }
          },

          // Navigation arrows
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },

          // Accessibility
          a11y: {
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
          }
        });

        // Add manual click handlers as backup
        if (nextButton && prevButton) {
          nextButton.addEventListener('click', function() {
            swiper.slideNext();
          });

          prevButton.addEventListener('click', function() {
            swiper.slidePrev();
          });
        }

      } catch (error) {
        console.error('DL Product Slider: Error initializing Swiper:', error);
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dl-product-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Find all product slider sections on the page
  const sliderSections = document.querySelectorAll('.dl-product-slider');

  sliderSections.forEach(function(sliderElement) {
    const swiperContainer = sliderElement.querySelector('.swiper');

    if (swiperContainer && typeof Swiper !== 'undefined') {
      const nextButton = sliderElement.querySelector('.dl-product-slider__button--next');
      const prevButton = sliderElement.querySelector('.dl-product-slider__button--prev');

      try {
        // Initialize Swiper for this specific instance
        new Swiper(swiperContainer, {
          // Basic settings
          loop: false,
          spaceBetween: 20,


          // Responsive breakpoints
          breakpoints: {
            // Mobile: show 1.5 products
            320: {
              slidesPerView: 1.5,
            },
            // Tablet portrait
            768: {
              slidesPerView: 2,
            },
            // Tablet landscape and up: show 3 products
            1024: {
              slidesPerView: 3,
            }
          },

          // Navigation arrows
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },

          // Accessibility
          a11y: {
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
          }
        });

      } catch (error) {
        console.error('DL Product Slider: Error initializing Swiper:', error);
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dl-provenance-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Find all provenance slider sections on the page
  const sliderSections = document.querySelectorAll('.dl-provenance-slider');
  
  sliderSections.forEach(function(sliderElement) {
    const sectionId = sliderElement.dataset.sectionId;
    const swiperContainer = sliderElement.querySelector('.swiper');
    
    if (swiperContainer && typeof Swiper !== 'undefined') {
      const nextButton = sliderElement.querySelector('.dl-provenance-slider__button--next');
      const prevButton = sliderElement.querySelector('.dl-provenance-slider__button--prev');
      
      try {
        // Initialize Swiper for this specific instance
        const swiper = new Swiper(swiperContainer, {
          // Basic settings
          loop: false,
          spaceBetween: 20,
          
          // Responsive breakpoints
          breakpoints: {
            // Mobile: show 1 item
            320: {
              slidesPerView: 1.5,
              spaceBetween: 10
            },
            // Tablet: show 2 items  
            768: {
              slidesPerView: 2,
              spaceBetween: 15
            },
            // Desktop: show 3 items
            1024: {
              slidesPerView: 3,
              spaceBetween: 20
            }
          },
          
          // Navigation arrows
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
          
          // Accessibility
          a11y: {
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
          }
        });
        
        // Add manual click handlers as backup
        if (nextButton && prevButton) {
          nextButton.addEventListener('click', function() {
            swiper.slideNext();
          });
          
          prevButton.addEventListener('click', function() {
            swiper.slidePrev();
          });
        }
        
      } catch (error) {
        console.error('DL Provenance Slider: Error initializing Swiper:', error);
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dl-story-slider-purpose"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Find all story slider sections on the page
  const sliderSections = document.querySelectorAll('.dl-story-slider');
  
  sliderSections.forEach(function(sliderElement) {
    const sectionId = sliderElement.dataset.sectionId;
    const swiperContainer = sliderElement.querySelector('.swiper');
    
    if (swiperContainer && typeof Swiper !== 'undefined') {
      const nextButton = sliderElement.querySelector('.dl-story-slider__button--next');
      const prevButton = sliderElement.querySelector('.dl-story-slider__button--prev');
      
      try {
        // Initialize Swiper for this specific instance
        const swiper = new Swiper(swiperContainer, {
          // Basic settings
          loop: false,
          spaceBetween: 20,
          
          // Responsive breakpoints
          breakpoints: {
            // Mobile: show 1.5 items
            320: {
              slidesPerView: 1.5,
            },
            // Tablet and up: show 2.5 items
            768: {
              slidesPerView: 2.5,
            }
          },
          
          // Navigation arrows
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
          
          // Accessibility
          a11y: {
            prevSlideMessage: 'Previous story',
            nextSlideMessage: 'Next story',
          }
        });
        
        // Add manual click handlers as backup
        if (nextButton && prevButton) {
          nextButton.addEventListener('click', function() {
            swiper.slideNext();
          });
          
          prevButton.addEventListener('click', function() {
            swiper.slidePrev();
          });
        }
        
      } catch (error) {
        console.error('DL Story Slider: Error initializing Swiper:', error);
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dl-story-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Find all story slider sections on the page
  const sliderSections = document.querySelectorAll('.dl-story-slider');
  
  sliderSections.forEach(function(sliderElement) {
    const sectionId = sliderElement.dataset.sectionId;
    const swiperContainer = sliderElement.querySelector('.swiper');
    
    if (swiperContainer && typeof Swiper !== 'undefined') {
      const nextButton = sliderElement.querySelector('.dl-story-slider__button--next');
      const prevButton = sliderElement.querySelector('.dl-story-slider__button--prev');
      
      try {
        // Initialize Swiper for this specific instance
        const swiper = new Swiper(swiperContainer, {
          // Basic settings
          loop: false,
          spaceBetween: 20,
          
          // Responsive breakpoints
          breakpoints: {
            // Mobile: show 1.5 items
            320: {
              slidesPerView: 1.5,
            },
            // Tablet and up: show 2.5 items
            768: {
              slidesPerView: 2.5,
            }
          },
          
          // Navigation arrows
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
          
          // Accessibility
          a11y: {
            prevSlideMessage: 'Previous story',
            nextSlideMessage: 'Next story',
          }
        });
        
        // Add manual click handlers as backup
        if (nextButton && prevButton) {
          nextButton.addEventListener('click', function() {
            swiper.slideNext();
          });
          
          prevButton.addEventListener('click', function() {
            swiper.slidePrev();
          });
        }
        
      } catch (error) {
        console.error('DL Story Slider: Error initializing Swiper:', error);
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dl-testimonials-faqs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    // Find all testimonials-faqs sections on the page
    const sections = document.querySelectorAll('.dl-testimonials-faqs');
    
    sections.forEach(function(section) {
        const sectionId = section.dataset.sectionId;
        
        // Initialize FAQs Slider
        const faqsSlider = section.querySelector('.dl-testimonials-faqs__faqs-slider');
        if (faqsSlider && typeof Swiper !== 'undefined') {
            const faqNextButton = section.querySelector('.dl-testimonials-faqs__faq-button--next');
            const faqPrevButton = section.querySelector('.dl-testimonials-faqs__faq-button--prev');
            
            try {
                const faqSwiper = new Swiper(faqsSlider, {
                    loop: false,
                    spaceBetween: 30,
                    slidesPerView: 1,
                    navigation: {
                        nextEl: faqNextButton,
                        prevEl: faqPrevButton,
                    },
                    a11y: {
                        prevSlideMessage: 'Previous FAQs',
                        nextSlideMessage: 'Next FAQs',
                    }
                });
                
                // Manual click handlers as backup
                if (faqNextButton && faqPrevButton) {
                    faqNextButton.addEventListener('click', function() {
                        faqSwiper.slideNext();
                    });
                    
                    faqPrevButton.addEventListener('click', function() {
                        faqSwiper.slidePrev();
                    });
                }
            } catch (error) {
                console.error('DL Testimonials FAQs: Error initializing FAQs Swiper:', error);
            }
        }
        
        // Initialize Videos Slider
        const videosSlider = section.querySelector('.dl-testimonials-faqs__slider');
        if (videosSlider && typeof Swiper !== 'undefined') {
            const videoNextButton = section.querySelector('.dl-testimonials-faqs__button--next');
            const videoPrevButton = section.querySelector('.dl-testimonials-faqs__button--prev');
            
            try {
                const videoSwiper = new Swiper(videosSlider, {
                    loop: true,
                    spaceBetween: 20,
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    navigation: {
                        nextEl: videoNextButton,
                        prevEl: videoPrevButton,
                    },
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    a11y: {
                        prevSlideMessage: 'Previous testimonials',
                        nextSlideMessage: 'Next testimonials',
                    }
                });
                
                // Manual click handlers as backup
                if (videoNextButton && videoPrevButton) {
                    videoNextButton.addEventListener('click', function() {
                        videoSwiper.slideNext();
                    });
                    
                    videoPrevButton.addEventListener('click', function() {
                        videoSwiper.slidePrev();
                    });
                }
            } catch (error) {
                console.error('DL Testimonials FAQs: Error initializing Videos Swiper:', error);
            }
        }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
